import { render, staticRenderFns } from "./storyAdmin.vue?vue&type=template&id=17036cab&"
import script from "./storyAdmin.vue?vue&type=script&lang=js&"
export * from "./storyAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports